var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckforbenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14008 0 0 3.14008 0 7C0 10.8599 3.14008 14 7 14C10.8599 14 14 10.8599 14 7C14 3.14008 10.8599 0 7 0ZM10.6167 6.132L8.03483 8.66658C7.57808 9.11458 6.99008 9.338 6.4015 9.338C5.81933 9.338 5.23717 9.11867 4.78217 8.67942L3.67442 7.59033C3.44458 7.36458 3.44167 6.99533 3.66742 6.7655C3.89258 6.53508 4.263 6.53217 4.49225 6.7585L5.5965 7.84408C6.04917 8.28158 6.76375 8.27925 7.21875 7.83358L9.8 5.29958C10.0292 5.07325 10.3973 5.07733 10.6248 5.30717C10.8506 5.537 10.8471 5.90625 10.6167 6.132Z",
    fill: "#57575C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckforbenefit);
export default __webpack_public_path__ + "static/media/checkforbenefit.c75374591dac520ef7b135f434995629.svg";
export { ForwardRef as ReactComponent };